jQuery(document).ready(
  (function ($) {
    return function () {
      function monkeyPatch_mouseStart() {
        // don't really need this, but in case I did, I could store it and chain
        var oldFn = $.ui.draggable.prototype._mouseStart,
          oldFn1 = $.ui.draggable.prototype._generatePosition,
          oldFn2 = $.ui.draggable.prototype._cacheHelperProportions;

        $.ui.draggable.prototype._mouseStart = function (event) {
          var o = this.options;

          function getViewOffset(node) {
            var x = 0,
              y = 0,
              win = node.ownerDocument.defaultView || window;
            if (node) addOffset(node);
            return { left: x, top: y };

            function getStyle(node) {
              return (
                node.currentStyle || win.getComputedStyle(node, "") // IE
              );
            }

            function addOffset(node) {
              var p = node.offsetParent,
                style,
                X,
                Y;
              x += parseInt(node.offsetLeft, 10) || 0;
              y += parseInt(node.offsetTop, 10) || 0;

              if (p) {
                x -= parseInt(p.scrollLeft, 10) || 0;
                y -= parseInt(p.scrollTop, 10) || 0;

                if (p.nodeType == 1) {
                  var parentStyle = getStyle(p),
                    localName = p.localName,
                    parent = node.parentNode;
                  if (parentStyle.position != "static") {
                    x += parseInt(parentStyle.borderLeftWidth, 10) || 0;
                    y += parseInt(parentStyle.borderTopWidth, 10) || 0;

                    if (localName == "TABLE") {
                      x += parseInt(parentStyle.paddingLeft, 10) || 0;
                      y += parseInt(parentStyle.paddingTop, 10) || 0;
                    } else if (localName == "BODY") {
                      style = getStyle(node);
                      x += parseInt(style.marginLeft, 10) || 0;
                      y += parseInt(style.marginTop, 10) || 0;
                    }
                  } else if (localName == "BODY") {
                    x += parseInt(parentStyle.borderLeftWidth, 10) || 0;
                    y += parseInt(parentStyle.borderTopWidth, 10) || 0;
                  }

                  while (p != parent) {
                    x -= parseInt(parent.scrollLeft, 10) || 0;
                    y -= parseInt(parent.scrollTop, 10) || 0;
                    parent = parent.parentNode;
                  }
                  addOffset(p);
                }
              } else {
                if (node.localName == "BODY") {
                  style = getStyle(node);
                  x += parseInt(style.borderLeftWidth, 10) || 0;
                  y += parseInt(style.borderTopWidth, 10) || 0;

                  var htmlStyle = getStyle(node.parentNode);
                  x -= parseInt(htmlStyle.paddingLeft, 10) || 0;
                  y -= parseInt(htmlStyle.paddingTop, 10) || 0;
                }

                if ((X = node.scrollLeft)) x += parseInt(X, 10) || 0;
                if ((Y = node.scrollTop)) y += parseInt(Y, 10) || 0;
              }
            }
          }

          //Create and append the visible helper
          this.helper = this._createHelper(event);

          //Cache the helper size
          this._cacheHelperProportions();

          //If ddmanager is used for droppables, set the global draggable
          if ($.ui.ddmanager) {
            $.ui.ddmanager.current = this;
          }

          /*
           * - Position generation -
           * This block generates everything position related - it's the core of draggables.
           */

          //Cache the margins of the original element
          this._cacheMargins();

          //Store the helper's css position
          this.cssPosition = this.helper.css("position");
          this.scrollParent = this.helper.scrollParent(true);
          this.offsetParent = this.helper.offsetParent();
          this.hasFixedAncestor =
            this.helper.parents().filter(function () {
              return $(this).css("position") === "fixed";
            }).length > 0;

          //The element's absolute position on the page minus margins
          this.positionAbs = getViewOffset(this.element[0]);

          this.offset = {
            top: this.positionAbs.top - this.margins.top,
            left: this.positionAbs.left - this.margins.left,
            scroll: false,
            parent: this._getParentOffset(),
            relative: this._getRelativeOffset()
          };

          this.offset1 = this.element.offset();
          this.offset1 = {
            top: this.offset1.top - this.margins.top,
            left: this.offset1.left - this.margins.left,
            scroll: false,
            parent: this._getParentOffset(),
            relative: this._getRelativeOffset()
          };

          $.extend(this.offset, {
            click: {
              //Where the click happened, relative to the element
              left: event.pageX - this.offset.left,
              top: event.pageY - this.offset.top
            },
            click1: {
              //Where the click happened, relative to the element
              left: event.pageX - this.offset1.left,
              top: event.pageY - this.offset1.top
            },
            parent: this._getParentOffset(),
            relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
          });

          //Generate the original position
          this.originalPosition = this.position = this._generatePosition(
            event,
            false
          );
          this.originalPageX = event.pageX;
          this.originalPageY = event.pageY;

          //Adjust the mouse offset relative to the helper if 'cursorAt' is supplied
          o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt);

          //Set a containment if given in the options
          if (o.containment) this._setContainment();

          //Trigger event + callbacks
          if (this._trigger("start", event) === false) {
            this._clear();
            return false;
          }

          //Recache the helper size
          this._cacheHelperProportions();

          //Prepare the droppable offsets
          if ($.ui.ddmanager && !o.dropBehaviour) {
            $.ui.ddmanager.prepareOffsets(this, event);
          }

          // Reset helper's right/bottom css if they're set and set explicit width/height instead
          // as this prevents resizing of elements with right/bottom set (see #7772)
          this._normalizeRightBottom();

          this.helper.addClass("ui-draggable-dragging");
          //JWL: Hier vindt de jump plaats
          this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

          //If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
          if ($.ui.ddmanager) {
            $.ui.ddmanager.dragStart(this, event);
          }

          return true;
        };

        $.ui.draggable.prototype._generatePosition = function (
          event,
          constrainPosition
        ) {
          var containment,
            co,
            top,
            left,
            o = this.options,
            scrollIsRootNode = this._isRootNode(this.scrollParent[0]),
            pageX = event.pageX,
            pageY = event.pageY;

          // Cache the scroll
          if (!scrollIsRootNode || !this.offset.scroll) {
            this.offset.scroll = {
              top: this.scrollParent.scrollTop(),
              left: this.scrollParent.scrollLeft()
            };
          }

          /*
           * - Position constraining -
           * Constrain the position to a mix of grid, containment.
           */

          if (constrainPosition) {
            //If we are not dragging yet, we won't check for options
            if (this.containment) {
              if (this.relativeContainer) {
                co = this.relativeContainer.offset();
                containment = [
                  this.containment[0] + co.left,
                  this.containment[1] + co.top,
                  this.containment[2] + co.left,
                  this.containment[3] + co.top
                ];
              } else {
                containment = this.containment;
              }

              if (event.pageX - this.offset.click1.left < containment[0]) {
                pageX = containment[0] + this.offset.click1.left;
              }
              if (event.pageY - this.offset.click1.top < containment[1]) {
                pageY = containment[1] + this.offset.click1.top;
              }
              if (event.pageX - this.offset.click1.left > containment[2]) {
                pageX = containment[2] + this.offset.click1.left;
              }
              if (event.pageY - this.offset.click1.top > containment[3]) {
                pageY = containment[3] + this.offset.click1.top;
              }
            }

            if (o.grid) {
              //Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
              top = o.grid[1]
                ? this.originalPageY +
                  Math.round((pageY - this.originalPageY) / o.grid[1]) *
                    o.grid[1]
                : this.originalPageY;
              pageY = containment
                ? top - this.offset.click1.top >= containment[1] ||
                  top - this.offset.click1.top > containment[3]
                  ? top
                  : top - this.offset.click1.top >= containment[1]
                  ? top - o.grid[1]
                  : top + o.grid[1]
                : top;

              left = o.grid[0]
                ? this.originalPageX +
                  Math.round((pageX - this.originalPageX) / o.grid[0]) *
                    o.grid[0]
                : this.originalPageX;
              pageX = containment
                ? left - this.offset.click1.left >= containment[0] ||
                  left - this.offset.click1.left > containment[2]
                  ? left
                  : left - this.offset.click1.left >= containment[0]
                  ? left - o.grid[0]
                  : left + o.grid[0]
                : left;
            }

            if (o.axis === "y") {
              pageX = this.originalPageX;
            }

            if (o.axis === "x") {
              pageY = this.originalPageY;
            }
          }

          return {
            top:
              pageY - // The absolute mouse position
              this.offset.click.top - // Click offset (relative to the element)
              this.offset.relative.top - // Only for relative positioned nodes: Relative offset from element to offset parent
              this.offset.parent.top + // The offsetParent's offset without borders (offset + border)
              (this.cssPosition === "fixed"
                ? -this.offset.scroll.top
                : scrollIsRootNode
                ? 0
                : this.offset.scroll.top),
            left:
              pageX - // The absolute mouse position
              this.offset.click.left - // Click offset (relative to the element)
              this.offset.relative.left - // Only for relative positioned nodes: Relative offset from element to offset parent
              this.offset.parent.left + // The offsetParent's offset without borders (offset + border)
              (this.cssPosition === "fixed"
                ? -this.offset.scroll.left
                : scrollIsRootNode
                ? 0
                : this.offset.scroll.left)
          };
        };
        ($.ui.draggable.prototype._convertPositionTo = function (d, pos) {
          var scale = $(".personalize_page.page.active").data("zoomScale");
          if (
            typeof scale == "undefined" ||
            (this.options.hasOwnProperty("disableScale") &&
              this.options.disableScale)
          )
            scale = 1;
          if (!pos) {
            pos = this.position;
          }

          var mod = d === "absolute" ? 1 : -1,
            scrollIsRootNode = this._isRootNode(this.scrollParent[0]);

          return {
            top:
              pos.top * scale + // The absolute mouse position
              this.offset.relative.top * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
              this.offset.parent.top * mod - // The offsetParent's offset without borders (offset + border)
              (this.cssPosition === "fixed"
                ? -this.offset.scroll.top
                : scrollIsRootNode
                ? 0
                : this.offset.scroll.top) *
                mod,
            left:
              pos.left * scale + // The absolute mouse position
              this.offset.relative.left * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
              this.offset.parent.left * mod - // The offsetParent's offset without borders (offset + border)
              (this.cssPosition === "fixed"
                ? -this.offset.scroll.left
                : scrollIsRootNode
                ? 0
                : this.offset.scroll.left) *
                mod
          };
        }),
          ($.ui.draggable.prototype._convertPositionTo1 = function (d, pos) {
            if (!pos) {
              pos = this.position;
            }

            var mod = d === "absolute" ? 1 : -1,
              scrollIsRootNode = this._isRootNode(this.scrollParent[0]);

            return {
              top:
                pos.top + // The absolute mouse position
                this.offset.relative.top * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.top * mod - // The offsetParent's offset without borders (offset + border)
                (this.cssPosition === "fixed"
                  ? -this.offset.scroll.top
                  : scrollIsRootNode
                  ? 0
                  : this.offset.scroll.top) *
                  mod,
              left:
                pos.left + // The absolute mouse position
                this.offset.relative.left * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.parent.left * mod - // The offsetParent's offset without borders (offset + border)
                (this.cssPosition === "fixed"
                  ? -this.offset.scroll.left
                  : scrollIsRootNode
                  ? 0
                  : this.offset.scroll.left) *
                  mod
            };
          }),
          ($.ui.draggable.prototype._cacheHelperProportions = function () {
            var dimensions = this.helper[0].getBoundingClientRect();
            this.helperProportions = {
              width: dimensions.width,
              height: dimensions.height
            };
          });
      }

      monkeyPatch_mouseStart();
    };
  })(jQuery)
);
